import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout/index.vue'
import Home from '@/pages/home/index.vue'
import MenuPage from '@/pages/menu-page/index.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', redirect: '/home' },
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home
      },
      {
        path: 'menu/:code',
        name: 'MenuPage',
        component: MenuPage,
        props: true
      },
      {
        path: 'menu/:code/detail/:id',
        name: 'MenuDetail',
        component: MenuPage,
        props: true
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router
